export default {
  companyName: "EPPF",
  copyRightStartYear: 2021,
  //serverHost: "http://localhost:6234/",
  //serverHost:"https://d16i5wlab0oam5.cloudfront.net/"
  serverHost:"https://d3cb7neg0tmd5h.cloudfront.net/"
};
